<script>
export default {
	props: ['showModal', 'isOpen'],
};
</script>

<template>
	<!-- Header links -->
	<div :class="isOpen ? 'block' : 'hidden'"
		class="m-0 sm:ml-4 mt-5 sm:mt-3 sm:flex p-5 sm:p-0 justify-center items-center shadow-lg sm:shadow-none">
		<router-link to="/" aria-label="Home" class="sm:mr-10">
			<h4>Home</h4>
		</router-link>

		<router-link to="/projects" aria-label="Projects" class="sm:mr-10">
			<h4>Projects</h4>
		</router-link>
		<router-link to="/about" aria-label="About Me" class="sm:mr-10">
			<h4>About Me</h4>
		</router-link>
		<!-- <router-link to="/contact" aria-label="Contact" class="sm:mr-10">
			<h4>Contact</h4>
		</router-link> -->
		<div>
			<router-link to="/contact" aria-label="Contact" class="font-general-medium sm:hidden block button-1">
				Hire Me
			</router-link>
		</div>
	</div>
</template>

<style lang="scss" scoped></style>
